import * as React from 'react'
import IProps from './IProps'
import { ExpandableIconType } from './IProps'
import { useTranslation } from 'react-i18next'

const ExpandableIcon = ({
    isExpanded,
    isActive = false,
    type,
    toggleExpanded,
    className,
}: IProps) => {
    const { t } = useTranslation()
    const expandedClassName = isExpanded ? 'expanded' : ''
    const activeClassName = isActive ? 'active' : ''
    const typeClass = type || ExpandableIconType.Primary

    return (
        <button
            className={`button button--expandable ${typeClass} ${expandedClassName} ${activeClassName} ${className ||
                ''}`}
            aria-label={t('global.expand')}
            onClick={() => toggleExpanded && toggleExpanded()}
        >
            <div
                className={`expandable__icon ${typeClass} ${expandedClassName} ${activeClassName} ${className ||
                    ''}`}
            ></div>
        </button>
    )
}

export default ExpandableIcon
